import React from 'react';
import { Col, Row, Statistic } from 'antd';
import { WarningOutlined, CheckCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { ValidationAlert } from '../../services/validation';
import CommonCard from '../CommonCard';

interface AlertStatsProps {
    alerts: ValidationAlert[];
}

const AlertStats: React.FC<AlertStatsProps> = ({ alerts }) => {
    const total = alerts.length;
    const resolved = alerts.filter((a) => a.is_resolved).length;
    const pending = total - resolved;
    const critical = alerts.filter((a) => !a.is_resolved && a.severity === 'CRITICAL').length;

    return (
        <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
            <Col xs={24} sm={8}>
                <CommonCard>
                    <Statistic
                        title="待处理报警"
                        value={pending}
                        valueStyle={{ color: pending > 0 ? '#cf1322' : '#3f8600' }}
                        prefix={<WarningOutlined />}
                        suffix={`/ ${total}`}
                    />
                </CommonCard>
            </Col>
            <Col xs={24} sm={8}>
                <CommonCard>
                    <Statistic
                        title="严重问题"
                        value={critical}
                        valueStyle={{ color: critical > 0 ? '#cf1322' : '#d9d9d9' }}
                        prefix={<InfoCircleOutlined />}
                    />
                </CommonCard>
            </Col>
            <Col xs={24} sm={8}>
                <CommonCard>
                    <Statistic
                        title="已解决"
                        value={resolved}
                        valueStyle={{ color: '#3f8600' }}
                        prefix={<CheckCircleOutlined />}
                    />
                </CommonCard>
            </Col>
        </Row>
    );
};

export default AlertStats;
